// extracted by mini-css-extract-plugin
module.exports = {"page":"Business_page__e1BxB"};